var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSetupLeftCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 90,
    viewBox: "0 0 116 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6017_2185",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -19,
    y: 0,
    width: 135,
    height: 90
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.5644 60.1167C86.0935 60.133 86.5249 59.7026 86.5249 59.1736V30.5019C86.5249 29.9732 86.0958 29.5441 85.5664 29.5441H56.8758C56.3464 29.5441 55.9158 29.9751 55.9321 30.5038C56.4297 46.6341 69.4237 59.6195 85.5644 60.1167Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2833 60.1167C25.7542 60.133 25.3227 59.7026 25.3227 59.1736V30.5019C25.3227 29.9732 25.7519 29.5441 26.2812 29.5441H54.9718C55.5012 29.5441 55.9319 29.9751 55.9156 30.5038C55.418 46.6341 42.4239 59.6195 26.2833 60.1167Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1384 1.19066C69.4735 0.301029 70.9478 0.301029 71.2828 1.19066C72.2545 3.77389 73.8465 7.29785 75.8925 9.34385C77.9384 11.3898 81.4626 12.982 84.0452 13.9535C84.9354 14.2887 84.9354 15.7629 84.0452 16.098C81.4626 17.0695 77.9384 18.6617 75.8925 20.7077C73.8465 22.7537 72.2545 26.2776 71.2828 28.8601C70.9478 29.7505 69.4735 29.7505 69.1384 28.8601C68.1668 26.2776 66.5747 22.7537 64.5287 20.7077C62.4827 18.6617 58.9587 17.0695 56.3755 16.098C55.4858 15.7629 55.4858 14.2887 56.3755 13.9535C58.9587 12.982 62.4827 11.3898 64.5287 9.34385C66.5747 7.29785 68.1668 3.77389 69.1384 1.19066Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.393 -4.83887e-08C115.015 -2.11809e-08 115.522 0.506429 115.499 1.12857C114.92 16.8301 102.295 29.4547 86.5936 30.034C85.9716 30.0573 85.465 29.5501 85.465 28.928L85.465 1.12706C85.465 0.504924 85.9696 -1.29081e-06 86.5921 -1.26361e-06L114.393 -4.83887e-08Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3543 1.14847C25.331 0.526329 25.8382 0.0198994 26.4603 0.0198994L54.2612 0.0199006C54.8834 0.0199007 55.3883 0.524825 55.3883 1.14697L55.3883 28.9479C55.3883 29.57 54.8819 30.0772 54.2597 30.0539C38.5582 29.4746 25.9336 16.85 25.3543 1.14847Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-5.26203 88.4265C-4.92692 89.3162 -3.45257 89.3162 -3.1176 88.4265C-2.14585 85.8433 -0.553909 82.3193 1.49209 80.2733C3.53801 78.2273 7.06219 76.6352 9.64483 75.6636C10.5351 75.3285 10.5351 73.8543 9.64483 73.5192C7.06219 72.5477 3.53801 70.9555 1.49209 68.9095C-0.553909 66.8635 -2.14585 63.3396 -3.1176 60.7571C-3.45257 59.8667 -4.92692 59.8667 -5.26204 60.7571C-6.23357 63.3396 -7.82573 66.8635 -9.87173 68.9095C-11.9177 70.9555 -15.4417 72.5477 -18.0249 73.5192C-18.9145 73.8543 -18.9145 75.3285 -18.0249 75.6636C-15.4417 76.6352 -11.9177 78.2273 -9.87173 80.2733C-7.82573 82.3193 -6.23356 85.8433 -5.26203 88.4265Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2328 60.1094C24.8553 60.1094 25.3621 59.6029 25.3391 58.9808C24.7594 43.2793 12.135 30.6547 -3.56651 30.0754C-4.18858 30.0521 -4.69515 30.5592 -4.69515 31.1814L-4.69515 58.9823C-4.69515 59.6045 -4.19053 60.1094 -3.56809 60.1094L24.2328 60.1094Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6017_2185)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.502,
    y: 89.0938,
    width: 117,
    height: 89.0917,
    transform: "rotate(180 115.502 89.0938)",
    fill: "#F0F0F0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSetupLeftCorner);
export default __webpack_public_path__ + "static/media/profile-setup-left-corner.d35c0c54b28d0b32e077d5340d7c4637.svg";
export { ForwardRef as ReactComponent };